export const iconFontAwesomeHumanitarianPersonWalking = (
	<i className="fa-solid fa-person-walking"></i>
);
